document.addEventListener('DOMContentLoaded', function() {
    const lightbox = document.querySelector('#careers-lightbox');
    const dialogPanel = lightbox.querySelector('.dialog-panel');
    const lightboxTemplate = document.querySelector('.lightbox-template');
    const openButtons = document.querySelectorAll('.trigger-lightbox');

    // Function to open lightbox with embed URL
    function openLightbox(embedUrl) {
        const clonedTemplate = lightboxTemplate.cloneNode(true);
        const iframe = clonedTemplate.querySelector('iframe');
        if (iframe) {
            iframe.src = embedUrl;
        }

        dialogPanel.appendChild(clonedTemplate);
        dialogPanel.setAttribute('aria-hidden', 'false');
        lightbox.removeAttribute('inert');
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Function to close lightbox
    function closeLightbox() {
        lightbox.classList.remove('active');
        lightbox.setAttribute('inert', '');

        while (dialogPanel.firstChild) {
            dialogPanel.removeChild(dialogPanel.firstChild);
        }

        dialogPanel.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    // Event delegation for trigger buttons
    document.addEventListener('click', function(e) {
        // Check if clicked element has trigger-lightbox class (and work for any elements inside it)
        if (e.target.closest('.trigger-lightbox')) {
            const embedUrl = e.target.closest('.trigger-lightbox').getAttribute('data-embed-url');
            if (embedUrl) {
                openLightbox(embedUrl);
            }
        }

        // Check if clicked element is close button
        if (e.target.classList.contains('close-lightbox')) {
            closeLightbox();
        }

        // Check if clicked element is overlay
        if (e.target.classList.contains('dialog-overlay')) {
            closeLightbox();
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && lightbox.classList.contains('active')) {
            closeLightbox();
        }
    });
});